import { twJoin } from "tailwind-merge";

import { useOrganizationUser } from "src/api/taktile/queries";
import { Avatar } from "src/design-system/Avatar";
import { Tooltip } from "src/design-system/Tooltip";
import { AuthorPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";
import { getUserName } from "src/utils/user";

type CanvasLockProps = {
  lockOwner: string;
  resource: "sidebar" | "node";
};

const DEFAULT_LOCK_OWNER_DATA = {
  username: "Unknown user",
};

export const CanvasLock: React.FC<CanvasLockProps> = ({
  lockOwner: lockOwnerId,
  resource,
}) => {
  const { orgId } = useParamsDecode<AuthorPageParams>();
  const { data: lockOwnerUser, isLoading } = useOrganizationUser(
    orgId,
    lockOwnerId,
  );

  return (
    <div
      className={twJoin(
        "absolute -z-10 translate-x-full",
        resource === "sidebar" && "top-2 -right-2",
        resource === "node" && "top-3 right-0",
      )}
    >
      <Tooltip
        body={`is currently editing this ${
          resource === "node" ? "Node" : "property"
        }...`}
        placement="top"
        title={getUserName(lockOwnerUser ?? DEFAULT_LOCK_OWNER_DATA)}
      >
        <div className="flex h-5.5 w-6.5 items-center rounded-r-xl bg-white pl-1.5 shadow-sm">
          {isLoading ? (
            <Avatar isLoading size="xs" />
          ) : (
            <Avatar size="xs" user={lockOwnerUser || DEFAULT_LOCK_OWNER_DATA} />
          )}
        </div>
      </Tooltip>
    </div>
  );
};
